
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, Typography, List, ListItem, ListItemText, ListItemAvatar, Avatar, Paper, CircularProgress, Alert, Modal, Box, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

function DashboardPage() {
  const [purchases, setPurchases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const handleOpen = (image) => {
    setSelectedImage(image);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setSelectedImage(null);
  };

  useEffect(() => {
    const fetchPurchases = async () => {
      try {
        const response = await axios.get('/api/users/my-purchases');
        setPurchases(response.data);
      } catch (err) {
        setError('Could not fetch purchases. Please try again later.');
        console.error('Error fetching purchases:', err);
      }
      setLoading(false);
    };

    fetchPurchases();
  }, []);

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" component="h1" gutterBottom sx={{ mt: 4, mb: 4 }}>
        My Purchased Photos
      </Typography>

      {loading && <CircularProgress />}
      {error && <Alert severity="error">{error}</Alert>}

      {!loading && !error && (
        <Paper elevation={2}>
          {purchases.length > 0 ? (
            <List>
              {purchases.map((purchase) => (
                <ListItem key={purchase.id} divider>
                  <ListItemAvatar onClick={() => handleOpen(purchase)} sx={{ cursor: 'pointer' }}>
                    <Avatar 
                      variant="square"
                      src={`/api/photos/thumb/${encodeURIComponent(purchase.thumbnail_filename)}`}
                      sx={{ width: 100, height: 100, mr: 2 }}
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={purchase.original_name}
                    secondary={`Race: ${purchase.raceName} - Purchased on: ${new Date(purchase.purchase_timestamp).toLocaleDateString()}`}
                  />
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body1" sx={{ p: 3 }}>
              You have not purchased any photos yet.
            </Typography>
          )}
        </Paper>
      )}

      {selectedImage && (
        <Modal
          open={modalOpen}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
            <img src={`/api/photos/${selectedImage.guid}`} alt={selectedImage.original_name} style={{ maxWidth: '80vw', maxHeight: '80vh' }} />
            <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
              <Button 
                variant="contained" 
                href={`/api/photos/download/${selectedImage.guid}`}
              >
                Download
              </Button>
            </Box>
          </Box>
        </Modal>
      )}
    </Container>
  );
}

export default DashboardPage;
